const ContactInfoItem = ({icon: Icon, title, text}) => (
  <div className="contact-info-item">
    <div className="icon-container">
      <Icon/>
    </div>
    <div className="title">{title}</div>
    {Array.isArray(text) &&
      text.map((t, i) => (
        <div className="text" key={i}>{t}</div>
      ))
    }
    {!Array.isArray(text) &&  <div className="text">{text}</div>}
  </div>
);

export default ContactInfoItem;
